import { SalesCommissionPricingModelLineContainerModel } from '../../../../../models/aggregates/sales-commission/sales-commission-pricing-model-line-container.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config } from '../shared';

@Injectable({
    providedIn: 'root'
})
export class SalesCommissionPricingModelLineService extends BaseApiTemplateService<SalesCommissionPricingModelLineContainerModel> {

    static readonly SALES_COMMISION_PRICING_MODEL_LINE_SUBPATH = 'sale-commission/pricing-model-lines/'

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + SalesCommissionPricingModelLineService.SALES_COMMISION_PRICING_MODEL_LINE_SUBPATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + SalesCommissionPricingModelLineService.SALES_COMMISION_PRICING_MODEL_LINE_SUBPATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.httpClient = http;
    }
}